import { useParent } from './coupled'

export default useParent('colgroup', { childrenKey: 'columns' })
